

















import { Component, Prop, Vue } from 'vue-property-decorator'
import { BtnTypesEnum } from '~/enums/components/UI/Btn/BtnTypesEnum'
import { BtnSizesEnum } from '~/enums/components/UI/Btn/BtnSizesEnum'
import { Location } from 'vue-router'
import { BtnColorsEnum } from '~/enums/components/UI/Btn/BtnColorsEnum'
import { BtnVariantEnum } from '~/enums/components/UI/Btn/BtnVariantEnum'

@Component
export default class Btn extends Vue {
  @Prop({
    type: String,
    default: BtnTypesEnum.Default
  })
  type: BtnTypesEnum

  @Prop({
    type: Boolean,
    default: false
  })
  loading: boolean

  @Prop({
    type: String,
    default: BtnSizesEnum.Default,
    validator: (value: BtnSizesEnum) => Object.values(BtnSizesEnum).includes(value)
  })
  size: BtnSizesEnum

  // Без validator: в отличие от size/variant, color принимает не только BtnColorsEnum,
  // но и произвольную CSS-строку как сырой фон (см. dynamicStyles ниже) — реальный
  // потребитель src/components/auth/SocialButtons.vue передаёт так хекс-цвета. Общего
  // способа отличить опечатку в имени элемента enum от валидного сырого цвета здесь нет.
  @Prop({
    type: String,
    default: BtnColorsEnum.Default
  })
  color: BtnColorsEnum

  @Prop({
    type: String,
    default: BtnVariantEnum.Default,
    validator: (value: BtnVariantEnum) => Object.values(BtnVariantEnum).includes(value)
  })
  variant: BtnVariantEnum

  @Prop({
    type: [String, Object],
    default: null
  })
  to: null | string | Location

  @Prop({
    type: String,
    default: null
  })
  href: null | string

  @Prop({
    type: Boolean,
    required: false
  })
  rounded: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  noMinWidth: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  noPrefetch: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  disabled: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  outlined: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  dark: boolean

  get isLink () {
    return this.to || this.href
  }

  get className (): string[] {
    const baseName = 'btn'
    const classNameBySize = {
      size: {
        [BtnSizesEnum.Big]: baseName + '--size-big'
      }
    }
    const className = [baseName]

    if (this.size) {
      if (this.size !== BtnSizesEnum.Default) {
        className.push(classNameBySize.size[this.size])
      }

      if (this.size === BtnSizesEnum.Big) {
        className.push('text-normal')
      } else if (this.size === BtnSizesEnum.Default) {
        className.push('text-small')
      }
    }
    if (this.outlined) className.push(baseName + '--outlined')
    if (this.rounded) className.push(baseName + '--rounded')
    if (this.disabled || this.loading) className.push(baseName + '--disabled')
    if (this.color !== BtnColorsEnum.Default && Object.values(BtnColorsEnum).includes(this.color)) {
      className.push(baseName + `--color-${this.color}`)
    }
    if (this.dark) {
      className.push(baseName + '--dark')
    }
    if (this.variant !== BtnVariantEnum.Default && Object.values(BtnVariantEnum).includes(this.variant)) {
      className.push(baseName + `--variant-${this.variant}`)
    }

    return className
  }

  get dynamicAttrs () {
    const attrs: Record<string, any> = {}

    if (this.isLink) {
      if (this.to) attrs.to = this.to
      if (this.href) attrs.href = this.href
      if (this.to && this.noPrefetch) attrs['no-prefetch'] = true

      attrs['no-link-class'] = true
    } else {
      attrs['type'] = 'submit'
    }

    return attrs
  }

  get dynamicStyles () {
    const styles: any = {}

    if (!this.noMinWidth && this.variant === BtnVariantEnum.Default) {
      styles['min-width'] = '120px'
    }
    if (!Object.values(BtnColorsEnum).includes(this.color)) {
      styles['background'] = this.color
    }

    return styles
  }
}
